/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPVerifyAttestationData
 */
export interface TOTPVerifyAttestationData {
    /**
     * 
     * @type {string}
     * @memberof TOTPVerifyAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the TOTPVerifyAttestationData interface.
 */
export function instanceOfTOTPVerifyAttestationData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TOTPVerifyAttestationDataFromJSON(json: any): TOTPVerifyAttestationData {
    return TOTPVerifyAttestationDataFromJSONTyped(json, false);
}

export function TOTPVerifyAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otp': !exists(json, 'otp') ? undefined : json['otp'],
    };
}

export function TOTPVerifyAttestationDataToJSON(value?: TOTPVerifyAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'otp': value.otp,
    };
}

